import { compose, withRouterProps } from 'utils/compose';

import TopBarSearch from '../components/TopBarSearch';
import { withAppsPageInfo } from './enhancers';

export default compose(
  withRouterProps,
  withAppsPageInfo
)(TopBarSearch);
